import styled, { css } from "styled-components";
import { CSSProp } from "styled-components";

export interface ColProps extends React.HTMLAttributes<HTMLDivElement> {
    gap?: number;
    flex?: number | string;
    alignItems?: "flex-start" | "flex-end" | "center" | "stretch" | "baseline";
    justifyContent?: "flex-start" | "flex-end" | "center" | "space-between" | "space-around" | "space-evenly" | "start" | "end";
    css?: CSSProp;
}

const ColRoot = styled.div<ColProps>`
    display: flex;
    flex-direction: column;
    ${({ gap }) =>
        gap !== undefined &&
        css`
            gap: ${gap}px;
        `}
    ${({ flex }) =>
        flex !== undefined &&
        css`
            flex: ${typeof flex === "number" ? flex : flex};
        `}
    ${({ alignItems }) =>
        alignItems &&
        css`
            align-items: ${alignItems};
        `}
    ${({ justifyContent }) =>
        justifyContent &&
        css`
            justify-content: ${justifyContent};
        `}
`;

// eslint-disable-next-line react/prop-types
const Col: React.FC<ColProps> = ({ children, ...props }) => {
    return <ColRoot {...props}>{children}</ColRoot>;
};

export default Col;


